<template>
  <div>
    <div class="head">
      <div class="headbar">
        <div class="container">
          <div class="head-lt">
            <a>欢迎回来到沃德珠宝！</a>
          </div>
          <div class="head-md webCSS">
            <marquee direction="left">
              温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
              1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
              2、实际到货后， 货品“地点”将变更为”HK”。
              3、下单即视为可以接受货品7个工作日之内到港。
              4、货品质量与香港现货库存一致。
            </marquee>
          </div>
        </div>
      </div>
      <div class="head-nav">
        <div class="header">
          <div class="header-lt">
            <div class="logo">
              <a href>
                <img src="/static/img/img/logo.png" />
              </a>
            </div>
          </div>
          <div class="header-ce">
            <div class="nav">
              <ul>
                <li @click="goPage('Home')">首页</li>
                <li @click="goPage('DiamondSearch')">GIA裸钻</li>
                <li @click="goPage('MyCar')">我的购物车</li>
                <li @click="goPage('MyOrder')">我的订单</li>
                <li @click="goPage('Calculator', true)">计算器</li>
                <li @click="goPage('FeedBack', true)">问题反馈</li>
                <li @click="goPage('ChangePass')">修改密码</li>
                <li @click="loginOut">注销登录</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="container-diam">
        <div class="title-box webCSS">
          <span class="title_1">我的订单</span>
        </div>
        <div class="clear"></div>
        <div class="container-form">
          <div id="wrapper">
            <div id="scroller">
              <div id="tabs" name="diamonds">
                <div id="tblist">
                  <ScrollX class="MyOrder-status" slot="headerExtend">
                        <div class="MyOrder-status-box">
                            <div class="MyOrder-status-item" :class="database.paging.order_status == item.id && 'active'" v-for="(item, index) in select.status" :key="index" @click="selectStatus(item.id)">{{item.name}}</div>
                        </div>
                    </ScrollX>
                  <table class="ltable">
                    <thead>
                      <tr>
                        <th>订单号</th>
                        <th>形状</th>
                        <th>重量</th>
                        <th></th>
                        <th class="style1">颜色</th>
                        <th>净度</th>
                        <th>折扣</th>
                        <th>切工</th>
                        <th>拋光</th>
                        <th>对称</th>
                        <th>荧光</th>
                        <th></th>
                        <th>价格</th>
                        <th>状态</th>
                        <th>件数</th>
                        <th>合计</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <tbody class="tbody" :onAreMore="hasMore" >
                        <tr id="row" class="statu_"  v-for="(item, index) in dataList" :key="index" >
                        <td>{{item.order_no}}</td>
                        <!-- <td>{{item}}</td> -->
                        <td>{{item.order_product[0].product_diamond.cnShape || '-'}}</td>
                        <td>{{item.order_product[0].product_diamond.d_size || '-'}}ct</td>
                        <td></td>
                        <td>{{item.order_product[0].product_diamond.color || '-'}}</td>
                        <td>{{item.order_product[0].product_diamond.clarity || '-'}}</td>
                        <td>{{0 - item.order_product[0].product_diamond.disc}}%</td>
                        <td>{{item.order_product[0].product_diamond.cut || '-'}}</td>
                        <td>{{item.order_product[0].product_diamond.polish || '-'}}</td>
                        <td>{{item.order_product[0].product_diamond.sym || '-'}}</td>
                        <td>{{item.order_product[0].product_diamond.flour || '-'}}</td>
                        <td></td>
                        <td>{{item.order_total_price || '-'}}</td>
                        <td style="color: red">{{item.order_state_msg}}</td>
                        <td>共{{item.order_product.length}}件</td>
                        <td style="color: red"> ¥ {{item.order_product[0].price || 0}}</td>
                        <td><button class="MyOrder-item-btn-info" v-if="item.order_state == 0" @click="cancelOrder(item)">取消订单</button> <div v-if="item.order_state == 4">订单已取消</div></td>
                        </tr>
                      <tr v-if="!dataList.length && options.isOk">
                        <td colspan="25" rowspan="4" style="height: 200px" >
                           <span>暂无相关订单.</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="board" style="display: none">
      <div class="board_title">
        <i class="fa fa-file-audio-o" aria-hidden="true"></i>公告栏
        <span>Notice Board</span>
        <a class="board_close"></a>
      </div>
      <p>
        温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
        1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
        2、实际到货后， 货品“地点”将变更为”HK”。
        3、下单即视为可以接受货品7个工作日之内到港。
        4、货品质量与香港现货库存一致。
      </p>
    </div>
    <div class="modelBox" style="display:none;">
      <div class="model">
        <img src />
        <p class="timeer">
          <span>4</span>&nbsp;S
        </p>
        <i class="closed">x</i>
      </div>
    </div>
  </div>
</template>
<script>
    import Core from '@/until/core'
    import ScrollPullDown from '@/public/ScrollPullDown'
    import ScrollX from '@/public/ScrollX'
    import SideMenu from '@/public/SideMenu'
    import _ from 'lodash'
    export default {
        name: 'MyOrder',
        data () {
            return {
                options: {
                    isOk: false,
                    refreshDelay: 0,
                    SideMenu: false
                },
                database: {
                    paging: {
                        order_status: 'all',
                        pagesize: 10,
                        pageint: 1,
                        totalrecord: 0,
                        totalpage: 0
                    },
                    list: []
                },
                select: {
                    status: [
                        {id: 'all', name: '全部'},
                        {id: 0, name: '待确认'},
                        {id: 1, name: '待发货'},
                        {id: 5, name: '已发货'},
                        {id: 9, name: '已收货'},
                        {id: 15, name: '已完成'},
                        {id: 4, name: '已取消'}
                    ]
                }
            }
        },
        components: {
            ScrollPullDown,
            ScrollX,
            SideMenu
        },
        watch: {},
        computed: {
            hasMore () {
                return this.database.paging.totalpage > this.database.paging.pageint
            },
            dataList () {
                const data = this.database.list || []
                const shape = ['ROUND', 'PRINCESS', 'PEAR', 'HEART', 'MARQUISE', 'OVAL', 'EMERALD', 'RADIANT', 'CUSHION', 'TRIANGLE']
                for (let value of data) {
                    if (value.order_product && value.order_product.length) {
                        for (let item of value.order_product) {
                            if (item.product_diamond.shape && shape.indexOf(item.product_diamond.shape) > -1) {
                                item.fullPath = '/static/img/' + item.product_diamond.shape.toLowerCase() + '.png'
                            }
                            if (!item.fullPath) {
                                item.fullPath = '/static/img/other.png'
                            }
                            item.price = parseInt(item.order_need_pay, 10) || 0
                        }
                    }
                    value.totalPrice = parseInt(value.order_need_pay, 10) || 0
                }
                return data
            },
            uid () {
                return this.$route.params.Uid
            }
        },
        filters: {},
        methods: {
            goPage (name, bool) {
                const that = this
                if (bool) {
                    return Core.goNext(name, that.$route.params)
                }
                Core.loginExist().then(res => {
                    if (res) {
                        return Core.goNext(name, that.$route.params)
                    }
                    Core.goNext('StaffLogin', that.$route.params)
                })
            },
            loginOut () {
                        Core.onRemoveToken()
                        Core.goNext('StaffLogin', this.$route.params, true)
                    },
            goBack () {
                Core.goBack()
            },
            onGetList () {
                const that = this
                that.$store.commit('onChangeAppLoaderShow', true)
                Core('Custommall/Order/DiamondOrderListing', that.database.paging).then(result => {
                    that.options.refreshDelay += 1
                    that.$store.commit('onChangeAppLoaderShow', false)
                    that.options.isOk = true
                    const res = result.data || {}
                    if (res.error_code || !res.data) {
                        return layer.msg(res.error_msg || '系统繁忙', {icon: 0})
                    }
                    that.database.paging.totalrecord = parseInt(res.data.totalrecord || 0, 10)
                    that.database.paging.totalpage = parseInt(res.data.totalpage || 0, 10)
                    that.database.list = _.concat([], that.database.list, res.data.list)
                })
            },
            onPullDown (done) {
                const that = this
                // 下拉加载
                if (!this.hasMore) {
                    return layer.msg('已经是最后一页了！')
                }
                if (that.database.paging.totalpage > that.database.paging.pageint) {
                    that.database.paging.pageint += 1
                    that.onGetList()
                }
                setTimeout(done, 2000)
            },
            resetList () {
                this.database.paging.pageint = 1
                this.database.list = []
            },
            selectStatus (id) {
                if (this.database.paging.order_status === id) {
                    return
                }
                this.database.paging.order_status = id
                this.resetList()
                this.onGetList()
            },
            cancelOrder (item) {
                const that = this
                layer.open({
                    title: '提示',
                    content: '确定要取消该订单吗？',
                    btn: ['确定', '取消'],
                    yes (index, layero) {
                        layer.close(index)
                        const param = {}
                        param.order_id = item.id
                        that.$store.commit('onChangeAppLoaderShow', true)
                        Core('Custommall/Order/CloseProduct', param).then(result => {
                            that.$store.commit('onChangeAppLoaderShow', false)
                            const res = result.data || {}
                            if (res.error_code || !res.data) {
                                return layer.msg(res.error_msg || '系统繁忙', {icon: 0})
                            }
                            layer.msg('订单已取消', {icon: 1})
                            that.resetList()
                            that.onGetList()
                        })
                    },
                    btn2 (index, layero) {
                        layer.close(index)
                    }
                })
            },
            onSideMenu (state) {
                this.options.SideMenu = false
            }
        },
        mounted () {
            const that = this
            that.onGetList()
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import '../../node_modules/swiper/dist/css/swiper.min.css';
@import '../../static/css/yellow.css';
@import '../../static/css/font-awesome.css';
@import '../../static/css/default.css';
.nav{ height: 90px; }
.header-ce{ width:1000px; }
.header-ce ul li{ float: left; line-height: 90px; width:100px; text-align: center;}
.Home-banner{ width: 100%; height: 600px; overflow: hidden; background-color: #fff; }
.btn-hk {
            color: #fff;
            padding: 8px 16px;
            line-height: 100px;
            background: #F268A3;
            border-radius: 2px;
            font-size: 13px;
        }

        .modelBox {
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: rgba(0, 0, 0, .65);
            overflow: hidden;
            z-index: 999;
        }

        .model {
            position: absolute;
            width: 1000px;
            height: 500px;
            margin: 0 auto;
            left: 0;
            right: 0;
            top: calc(50% - 350px);
            z-index: 9999;
            text-align: center;
            padding: 50px 0;
        }

        .closed {
            display: block;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            position: absolute;
            right: 150px;
            top: 120px;
            text-align: center;
            line-height: 22px;
            background: #e0b12f;
            color: #fff;
            font-size: 14px;
            cursor: pointer;

        }

        .timeer {
            text-align: center;
            position: absolute;
            bottom: 0;
            width: 100px;
            margin: auto;
            left: 0;
            right: 0;
            line-height: 40px;
            font-size: 14px;
            color: #FFEB3B;
            font-size: 30px;
            border-radius: 5px;
        }
.nav {
  height: 90px;
}
.header-ce {
  width: 1000px;
}
.header-ce ul li {
  float: left;
  line-height: 90px;
  width: 100px;
  text-align: center;
}
.list-none{ margin-top:200px; font-size: 40px; }
    .MyOrder-main{ width: 100%; padding: 0 0 1px; height: 600px; overflow: auto; }
    .MyOrder-info{ width: 100%; height: 240px; padding: 20px 26px 20px 240px; position: relative; }
    .MyOrder-info-img{ position: absolute; left: 20px; top: 20px; width: 200px; height: 200px; border-radius: 10px; overflow: hidden; background-color: #fbfbfb; }
    .MyOrder-info-item{ width: 100%; height: 36px; line-height: 36px; font-size: 20px; overflow: hidden; }
    .MyOrder-info-item-info{ float: left; width: 33.333%; height: 100%; overflow: hidden; }
    .MyOrder-info-item-info.left{ padding-left: 20px; }
    .MyOrder-info-item-info.full{ width: 100%; }
    .MyOrder-info-item-info.half{ width: 50%; }
    .MyOrder-info-price{ position: absolute; left:240px; bottom: 20px; line-height: 50px; font-size: 25px; color: #ff410f; }
    .MyOrder-info-btn{ position: absolute; right: 0; bottom: 0; height: 0.5rem; line-height: 0.46rem; padding: 0 20px; border: 1px solid #ff410f; color: #ff410f; font-size: 0.26rem; border-radius: 0.25rem; }

    .MyOrder-status{ z-index: 10; white-space:nowrap; }
    .MyOrder-status-item{ display: inline-block; padding: 10px 20px; line-height: 35px; font-size: 18px; }
    .MyOrder-status-box{ width: min-content; }
    .MyOrder-status-item.active{ color: #ff410f; }

    .MyOrder-item{ width: 100%; background-color: #fff;  }
    .MyOrder-item-title{ width: 100%; height: 80px; line-height: 80px; font-size: 20px; padding: 0 20px; border-bottom: 1px solid #e0e0e0; position: relative; }
    .MyOrder-item-status{ position: absolute; right: 20px; top: 0; color: #ff410f; }
    .MyOrder-item-btn{ width: 100%; height: 70px; border-top: 1px solid #e0e0e0; background-color: #fff; padding: 15px 20px; border-bottom: 1px solid #e0e0e0; }
    .MyOrder-item-btn-info{  border: 1px solid #7e7e7e;  color: #7e7e7e;  background-color: #fff; }
    .MyOrder-item-btn-text{ float: left; height: 100%; line-height: 50px; font-size: 20px; }

    .MyOrder-item-box{ width: 100%; padding: 70px 0; }
</style>



// WEBPACK FOOTER //
// src/components/MyOrder.vue